module.exports = __webpack_public_path__ + "static/img/mi-cover.8a496e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Home-pics/mi-cover.jpg
// module id = zNKM
// module chunks = 0